// extracted by mini-css-extract-plugin
export var askAiIcon = "_oa-j";
export var category = "_oa-9";
export var categoryHeader = "_oa-e";
export var container = "_oa-0";
export var group = "_oa-a";
export var groupItems = "_oa-f";
export var groupSeparator = "_oa-k";
export var loading = "_oa-1";
export var noResults = "_oa-3";
export var placeholder = "_oa-2";
export var resultContent = "_oa-5";
export var resultIcon = "_oa-c";
export var resultItem = "_oa-g";
export var resultMeta = "_oa-8";
export var resultSubtitle = "_oa-7";
export var resultSuffix = "_oa-i";
export var resultTitle = "_oa-6";
export var resultsList = "_oa-4";
export var searchGroup = "_oa-d";
export var selected = "_oa-h";
export var subgroup = "_oa-b";